//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUpload from '@/components/file-upload'
import DivSpan from '@/components/DivSpan'

export default {
  name: "purchase-order-view",

  components: {
    fileUpload,
    DivSpan,
  },
  data() {
    return {
      orderDto: {},
      gridList: [
        {icon: require('@/assets/icon/supplier/supplier_base_data.png'), label: '基本信息'},
        {icon: require('@/assets/icon/supplier/bidding_detail.png'), label: '订单明细'},
        {icon: require('@/assets/icon/supplier/com_order_details.png'), label: '收货地址'},
      ],
      index: 1
    }
  },
  methods: {
    itemTab(index) {
      this.index = index;
    },
    getOrderDto() {
      this.$loadingShow();
      this.$get('api/purOrder/' + this.dataId).then((data) => {
        if (data) {
          this.orderDto = data;
        }
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    changeOrd(orderDetail) {
      if (orderDetail.show) {
        this.$set(orderDetail, 'show', false);
        return;
      }
      this.$set(orderDetail, 'show', true);
    },
    switchTabItem(e, info) {
      e['list'] = info;
      this.$forceUpdate();
    },
  },
  mounted() {
    this.dataId = this.$route.params.id;
    this.getOrderDto();
  },
}



// WEBPACK FOOTER //
// ./src/page/purchase-order/purchase-order-view.vue